/**
 * Standard API error structure and classes for handling Experience API errors.
 */

export interface ApiErrorResponse {
  message: string;
  code?: string;
  details?: Record<string, any>;
  status?: number;
}

export class ApiError extends Error {
  public readonly status?: number;
  public readonly code?: string;
  public readonly details?: Record<string, any>;

  constructor(message: string, status?: number, code?: string, details?: Record<string, any>) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
    Object.setPrototypeOf(this, ApiError.prototype);
  }
}

export class UnauthorizedError extends ApiError {
  constructor(message = 'Não autorizado. Faça login novamente.', details?: Record<string, any>) {
    super(message, 401, 'UNAUTHORIZED', details);
    this.name = 'UnauthorizedError';
  }
}

export class ForbiddenError extends ApiError {
  constructor(message = 'Acesso negado. Você não possui as permissões necessárias.', details?: Record<string, any>) {
    super(message, 403, 'FORBIDDEN', details);
    this.name = 'ForbiddenError';
  }
}

export class NotFoundError extends ApiError {
  constructor(message = 'Recurso não encontrado.', details?: Record<string, any>) {
    super(message, 404, 'NOT_FOUND', details);
    this.name = 'NotFoundError';
  }
}

export class ValidationError extends ApiError {
  constructor(message = 'Dados inválidos.', details?: Record<string, any>) {
    super(message, 400, 'VALIDATION_ERROR', details);
    this.name = 'ValidationError';
  }
}

export class InternalServerError extends ApiError {
  constructor(message = 'Ocorreu um erro interno no servidor.', details?: Record<string, any>) {
    super(message, 500, 'INTERNAL_SERVER_ERROR', details);
    this.name = 'InternalServerError';
  }
}
